/* eslint-disable react/prop-types */

import * as React from 'react';
import { withRouter } from 'react-router-dom';

class RouteHandler extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { location, history: { action } } = nextProps;
    if (location !== this.props.location && action === 'PUSH') {
      // new navigation - scroll to top
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(RouteHandler);



// WEBPACK FOOTER //
// ./src/browser/RouteHandler.js